import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  prequalDataSelector,
  appRequestSelector,
} from "containers/MultistepForm/selectors";
import { selectOffer } from "containers/MultistepForm/actions";
import ProgressiveLogo from "../../../../../assets/img/progressive-logo.png";
import Calendar from "assets/img/calendar_icon.svg";
import { normalizeSNN, onlyNumbers } from "utils/normalize";
import { required, isNumEqual9 } from "utils/validations";
import {
  renderField,
  renderPayFrequencyField,
  renderPayoutDayField,
  renderLastPaycheckField,
  getNextPaycheckDate,
} from "containers/MultistepForm/Step2/input_helpers";
import CustomDateField from "components/CustomFields/CustomDateField";
import "./styles.scss";

const selector = formValueSelector("prequal_employment_form");

class PrequalEmploymentForm extends Component {
  state = {
    showPayoutDayOption: false,
    payoutDay: "first",
    payoutFrequency: "",
    clearLastPaydate: false,
    nextPaycheckDate: null,
  };

  componentDidMount() {
    const { prequalData } = this.props;
    if (prequalData?.pay_frequency) {
      this.setState({
        payoutFrequency: prequalData.pay_frequency,
        showPayoutDayOption: prequalData.pay_frequency === "semi_monthly",
      });
    }
  }

  setPayoutFrequency = (value) => {
    this.setState({
      payoutFrequency: value,
      showPayoutDayOption: value === "semi_monthly",
      clearLastPaydate: true,
      nextPaycheckDate: null,
    });
  };

  setPayoutDay = (value) => {
    this.setState({
      payoutDay: value,
      clearLastPaydate: true,
      nextPaycheckDate: null,
    });
  };

  onChangeLastPaydate = (date) => {
    const { payoutFrequency, payoutDay } = this.state;
    this.setState({
      clearLastPaydate: false,
      nextPaycheckDate: getNextPaycheckDate(payoutFrequency, date, payoutDay),
    });
  };

  submitForm = () => {
    const { prequalData, appRequest, ssn, payFrequency, lastPaycheck } =
      this.props;
    const { nextPaycheckDate } = this.state;

    this.props.selectOffer({
      selectedOffer: {
        app_id: prequalData.app_id,
        provider: "progressive",
        specific_provider_name: "progressive",
        banking_data: true,
        offer_id: prequalData.application_id,
        approval_amount: prequalData.approval_amount,
        cart_total: prequalData.cart_total,
        has_additional_info: true,
        additional_info_data: {},
        personalInfo: {
          ...appRequest.personalInfo,
          ssn: onlyNumbers(ssn),
        },
        employmentInformation: {
          payFrequency: payFrequency,
          last_payday_on: lastPaycheck,
          next_payday_on: nextPaycheckDate,
          direct_deposit: true,
        },
      },
    });
  };

  render() {
    const { loading, valid } = this.props;
    const { nextPaycheckDate, showPayoutDayOption, payoutFrequency, clearLastPaydate, payoutDay } = this.state;

    return (
      <div className="expanded-block-component bank-data-form-container">
        <div className="bank-data-form-header">
          <img src={ProgressiveLogo} alt="Progressive Logo" />
          <h1>Apply for Lease-to-Own</h1>
          <h2>Additional Information</h2>
        </div>

        <div className="step2__form paypair-form prequal-employment-form">
          <div className="form-item form-item--ssn">
            <Field
              name="ssn"
              validate={[required, isNumEqual9]}
              component={renderField}
              normalize={normalizeSNN}
            />
          </div>

          <div className="form-item-group">
            <div className="form-item form-item--frequency-payment">
              <Field
                name="payFrequency"
                validate={required}
                component={renderPayFrequencyField}
                onChange={this.setPayoutFrequency}
                label={"* How often do you get paid?"}
              />
            </div>
          </div>

          {showPayoutDayOption && (
            <div className="form-item form-item--frequency-payment frequency-payment-input">
              <Field
                name="payoutDay"
                validate={required}
                component={renderPayoutDayField}
                onChange={this.setPayoutDay}
                label={
                  "* Are you paid on the first or the last day of the month?"
                }
              />
            </div>
          )}

          <div className="form-item last-pay-ckeck_input">
            <img src={Calendar} className="calendar-icon" />
            <CustomDateField
              name="lastPaycheck"
              payoutFrequency={payoutFrequency}
              payoutDay={payoutDay}
              validate={[required]}
              component={renderLastPaycheckField}
              onChange={this.onChangeLastPaydate}
              reset={clearLastPaydate}
              label={"* Last paycheck date"}
            />
          </div>
        </div>

        <BlueBtn
          customClass="bank-data-form-submit-btn"
          disabled={!valid || !nextPaycheckDate}
          loading={loading}
          onClick={this.submitForm}
        >
          Continue
        </BlueBtn>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  prequalData: prequalDataSelector()(state),
  appRequest: appRequestSelector()(state),
  ssn: selector(state, "ssn"),
  payFrequency: selector(state, "payFrequency"),
  lastPaycheck: selector(state, "lastPaycheck"),
  initialValues: {
    payFrequency: prequalDataSelector()(state)?.pay_frequency,
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
  };
};

PrequalEmploymentForm = reduxForm({
  form: "prequal_employment_form",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PrequalEmploymentForm);

PrequalEmploymentForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrequalEmploymentForm);

export default PrequalEmploymentForm;
